import EmployeeRates from './EmployeeRates';

export default EmployeeRates;